import { MapFactProps } from '../../../components/map-fact';

export const facts: MapFactProps[] = [
  {
    aboveValue: `Our goal is to recycle 45% of wastewater by 2030.`,
    position: 'top-left',
  },
  {
    aboveValue: `Wastewater is 99.9% water and mostly comes from kitchen sinks, showers and washing machines.`,
    position: 'bottom-right',
  },
  {
    aboveValue: `Did you know each day we take away 370 million litres of wastewater from your homes?`,
    position: 'top-right',
  },
  {
    aboveValue: `Around 80% of WA's wastewater is treated at one of our 3 treatment plants: Woodman Point, Beenyup (Craigie) and Subiaco.`,
    position: 'bottom-left',
  },
  {
    aboveValue: `Help protect our wastewater system by watching what goes down the drain. When using the toilet remember to flush only the 3 P's - paper, pee and poo - down the loo.`,
    position: 'top-left',
  },
];
